import { useState, useEffect, useCallback } from 'react'

export function useExitIntent(options: { delay?: number; threshold?: number } = {}) {
  const { delay = 3000, threshold = 20 } = options
  const [showPopup, setShowPopup] = useState(false)
  const [hasTriggered, setHasTriggered] = useState(false)

  const handleMouseLeave = useCallback((e: MouseEvent) => {
    if (hasTriggered) return

    // Check if mouse is leaving from top of viewport
    if (e.clientY <= threshold) {
      setShowPopup(true)
      setHasTriggered(true)
      // Store in sessionStorage so it doesn't show again this session
      sessionStorage.setItem('exitIntentShown', 'true')
    }
  }, [hasTriggered, threshold])

  useEffect(() => {
    // Don't show if already shown this session
    if (sessionStorage.getItem('exitIntentShown')) {
      setHasTriggered(true)
      return
    }

    // Wait before enabling exit intent
    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave)
    }, delay)

    return () => {
      clearTimeout(timer)
      document.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [delay, handleMouseLeave])

  const closePopup = () => setShowPopup(false)

  return { showPopup, closePopup }
}
